<h1 mat-dialog-title>{{ creating ? 'Connect The Trade Desk' : 'The Trade Desk Integration' }}</h1>

<div class="content" mat-dialog-content>
  <p>Connect your The Trade Desk account to Advocado Activate for real time bidding.</p>
  <mat-spinner *ngIf="loading" diameter="40"></mat-spinner>
  <div *ngIf="creating && accounts && accounts.length > 0 && !loading">
    <mat-form-field>
      <mat-select placeholder="Select an Advertiser" [(ngModel)]="adAccount">
        <mat-option *ngFor="let account of accounts" [value]="account.AdvertiserId">
          {{ account.AdvertiserName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="isAdmin && !creating && existingIntegrations.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      Add The Trade Desk Account
    </button>
  </div>

  <div *ngIf="!creating">
    <div *ngFor="let int of existingIntegrations">Advertiser Name: {{ int.friendlyName }}</div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      *ngIf="creating && accounts"
      [disabled]="!adAccount"
      mat-raised-button
      [appShowSpinner]="saving"
      [buttonText]="'Save'"
      (click)="save($event)"
      color="primary"
    >
      Save
    </button>
  </div>
</div>
